const ValidateDataService = {
    isEmptyValue: (value) => [null, undefined, ""].includes(value),
};

export default ValidateDataService;
